import { BigNumber, utils } from 'ethers';

import kosmosIcon from '../../assets/icons/kosmos.svg';

import { secondsToDhms } from '../../utils/secondsToDhms';
import { formatTimeInterval } from '../../utils';
import formatPercent from '../../utils/formatPercent';
import { InfoDataProps, RewardsStateProps } from '../../hooks/types';

import { useFormatter, NumberType } from '../../utils/formatNumbers';

const InfoBlock = ({
  stateRewards,
  data,
}: {
  stateRewards: RewardsStateProps;
  data: InfoDataProps;
}) => {
  const {
    lockAmount,
    timeFrame,
    stakingTokenBalance,
    stakingTokenDecimals,
    rewardParams,
  } = data;

  const { getTier } = stateRewards;

  const rewardAPY = BigNumber.from(getTier.level).isZero()
    ? '10%'
    : formatPercent(rewardParams.rewardAPY);

  const { formatNumberOrString } = useFormatter();

  return (
    <div className="info-block">
      <h1 className="title">
        <img src={kosmosIcon} alt="kosmos" />
        KOSMOS
      </h1>
      <div className="info_list">
        <div>
          <p className="info_list_label">MY KOS</p>
          <p className="info_list_value">
            {lockAmount && stakingTokenBalance
              ? formatNumberOrString({
                  input: utils.formatUnits(
                    BigNumber.from(lockAmount).add(
                      BigNumber.from(stakingTokenBalance),
                    ),
                    stakingTokenDecimals,
                  ),
                  type: NumberType.TokenNonTx,
                })
              : '-'}
          </p>
        </div>
        <div>
          <p className="info_list_label">KOS STAKED</p>
          <p className="info_list_value">
            {formatNumberOrString({
              input: utils.formatUnits(lockAmount, stakingTokenDecimals),
              type: NumberType.TokenNonTx,
            })}
          </p>
        </div>
        <div>
          <p className="info_list_label">KOS AVAILABLE</p>
          <p className="info_list_value">
            {formatNumberOrString({
              input: utils.formatUnits(
                stakingTokenBalance,
                stakingTokenDecimals,
              ),
              type: NumberType.TokenNonTx,
            })}
          </p>
        </div>
        <div>
          <p className="info_list_label">STAKING APY</p>
          <p className="info_list_value">{rewardAPY}</p>
        </div>
        <div>
          <p className="info_list_label">REWARD SEASON</p>
          <p className="info_list_value">
            {timeFrame ? formatTimeInterval(timeFrame) : '-'}
          </p>
        </div>
        <div>
          <p className="info_list_label">END OF SEASON</p>
          <p className="info_list_value">
            {timeFrame?.endTime
              ? secondsToDhms(BigNumber.from(timeFrame?.endTime).toNumber())
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoBlock;
